import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const BrandIdentityDevelopment = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/uiux-4.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                  <h1 id="heading_line">Brand Identity Development: Crafting a Unique and Memorable Presence</h1>
                  <h2 id="sub_heading1">
                  At Codeflix,we specialize in Brand Identity Development, helping businesses establish a distinct and compelling brand presence that resonates with their audience. A strong brand identity is more than just a logo or a color scheme—it represents your company’s values, mission, and personality. Our team works closely with you to create a cohesive and impactful brand identity that fosters recognition, trust, and customer loyalty.
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="why_coustom_app">
            <div className="wrapper">
              <h3>
              Why Invest in <span>Brand Identity Development ?</span>
              </h3>
                <p>A well-crafted brand identity is essential for standing out in a crowded marketplace. It builds credibility, establishes emotional connections with customers, and differentiates your business from competitors. By defining your brand’s visual and verbal elements, we ensure consistency across all marketing channels, from websites and social media to print materials and packaging. A compelling brand identity helps businesses increase brand recall, strengthen customer loyalty, and drive long-term growth.</p>
                <h3><span>Our Brand Identity Development Process</span></h3>
                <h4>1. Discovery & Strategy</h4>
                <p>Understanding the essence of your brand is the first step toward crafting a strong identity. Our team conducts in-depth research to explore your company’s values, goals, target audience, and industry landscape. Through stakeholder interviews and competitive analysis, we gain insights that guide the brand development process. We define your brand mission, vision, and unique value proposition, ensuring your identity aligns with business objectives.</p>
                <h4>2. Logo & Visual Identity Design</h4>
                <p>Your logo is the face of your brand, and we design logos that are distinctive, versatile, and timeless. Beyond logo creation, we establish a comprehensive visual identity that includes:</p>
                <ul>
                    <li>Color Palette – Carefully selected colors that evoke the right emotions and align with your brand personality.</li>
                    <li>Typography – Fonts that reflect your brand’s tone and ensure readability across all mediums.</li>
                    <li>Imagery & Iconography – Consistent graphic elements that enhance brand storytelling.</li>
                    <li>Brand Guidelines – A structured set of rules ensuring design consistency across platforms.</li>
                </ul>
                <h4>3. Brand Messaging & Voice</h4>
                <p>A strong brand is not only visually appealing but also communicates effectively. We craft brand messaging frameworks, including your tagline, tone of voice, and key messaging pillars. Whether your brand voice is professional, friendly, authoritative, or playful, we ensure it aligns with your audience’s expectations and remains consistent in all communication.</p>
                <h4>4. Website & Digital Branding</h4>
                <p>Your online presence is a critical touchpoint for customers. We design and develop branded websites, social media assets, and digital marketing materials that reinforce your identity. Our digital branding services include:</p>
                <ul>
                    <li>Website Design & UI/UX Optimization</li>
                    <li>Social Media Profile Branding & Content Templates</li>
                    <li>Email & Marketing Collateral Design</li>
                </ul>
                <h3><span>5. Brand Implementation & Consistency</span></h3>
                <p>Creating a brand identity is just the beginning; ensuring consistency across all customer interactions is key. We provide brand rollout strategies and implementation support to help businesses seamlessly integrate their new identity. Our team offers brand training workshops, marketing collateral design, and ongoing brand evolution strategies to ensure long-term success.</p>
              <h3><span>Industries We Serve</span></h3>
              <p>Our Brand Identity Development Services cater to various industries, including:</p>
                <ul>
                  <li><b>Startups & Entrepreneurs </b>Establishing a unique identity from the ground up.</li>
                  <li><b>E-commerce & Retail </b>Creating compelling branding for online and offline stores.</li>
                  <li><b>Healthcare & Wellness </b>Building trust with a strong and professional brand presence.</li>
                  <li><b>Finance & Corporate </b>Developing sophisticated and authoritative brand identities.</li>
                  <li><b>Technology & SaaS </b>Crafting modern, innovative, and scalable branding solutions.</li>
                </ul>
                <h3><span>Get Started with Us!</span></h3>
                <p>Your brand identity is the foundation of your business’s success. At Codeflix, we are dedicated to creating visually stunning, strategically developed, and impactful brand identities that leave a lasting impression. Whether you need a complete brand overhaul or a fresh new look, we are here to help. Contact us today at info@codeflixweb.com to begin your brand transformation!</p>
            </div>
            
          </div>
          <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
                  </div>
                <div className="let_build">
                    <div className="wrapper">
                    <h4>Let’s Build <span> Your App Together </span></h4>
                  
                  <p>
                    Whether you’re a startup looking to disrupt the market or an
                    established enterprise aiming to enhance operational efficiency,
                    CodeFlix is here to bring your vision to life. Let’s create a
                    custom mobile app that drives results and delights your users.{" "}
                    <br />
                    Contact Us today to get started on your mobile app development
                    journey.
                  </p>
                    </div>
                </div>
        </>
      );
};
export default BrandIdentityDevelopment;
